import { useI18n } from "./integrations/formatjs/I18nContext";
const useI18nDate = ({ domain, value, dateStyle, timeZone, }) => {
    const intl = useI18n({ domain });
    return intl.formatDate(value, { dateStyle, timeZone });
};
export { useI18nDate };
